export { default } from '../../components/CollectionIndex';
